import { Component, OnInit, Output, EventEmitter, Input,OnChanges } from '@angular/core';

import * as _ from 'lodash';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})

export class CalendarComponent implements OnInit ,OnChanges{
  @Output() emitDate = new EventEmitter();
  @Output() emitMonth = new EventEmitter();
  @Output() emitDateDrow = new EventEmitter();

  @Input() infoList = Array<Input_InfoListObj>();


  YYYY = null;
  MM = null;
  DD = null;


  typeMonthFlag = false;//日曆與月曆
  printDays: Array<Array<PrintDayObj>>;
  printMonth: Array<string >;

  infoColor=[
    "#338a96",
    "rgb(64 176 191 / 85%)",
    "#52cbdb",
    "rgb(64 176 191 / 45%)"
  ]

  constructor() { }

  ngOnInit() {
    this.createCale()
    this.insertInfo();
  }

  ngOnChanges(){
    console.log('change infoList',this.infoList)
    this.insertInfo();
  }

  //建立日歷
  createCale() {

    let date = new Date();
    //date.setFullYear(y);
    // date.setMonth(m);



    //預設當前時段
    if (this.YYYY == null) this.YYYY = date.getFullYear();
    //else date.setFullYear(this.YYYY)
    if (this.MM == null) this.MM = date.getMonth();
    //else date.setMonth(this.MM)
    if (this.DD == null) this.DD = date.getDate();


    //每月日數陣列
    let monthDays = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);

    // 閏年判斷	 
    let mYear = this.YYYY;
    if (((mYear % 4 == 0) && (mYear % 100 != 0)) || (mYear % 400 == 0)) monthDays[1] = 29;

    //起始星期幾判斷   
    let a = new Date(this.YYYY + '/' + (this.MM + 1) + '/01');
    let startWeekday = a.getDay();
    console.log(this.YYYY + '/' + (this.MM + 1) + '/' + this.DD + '星' + a + '..' + a.getDay())


    //-----日曆內容填入------    
    let dayList = [];
    //1號之前的空白星期 當前格式日 一 二... 如替換成 一 二 三...weekday須減1
    for (let i = 0; i < startWeekday; i++) {
      let obj = new PrintDayObj();
      obj.DD="";
      dayList.push(obj);
    }

    //日期碼   
    for (let i = 1; i <= monthDays[this.MM]; i++) {
      let obj = new PrintDayObj();
      obj.DD=i.toString();
      dayList.push(obj);
    }
    //分割成七天一列
    this.printDays = _.chunk(dayList, 7)

    //補上剩下的空白
    let empty = 7 - this.printDays[this.printDays.length - 1].length
    for (let i = 0; i < empty; i++) {

      let obj = new PrintDayObj();
      obj.DD="";
      this.printDays[this.printDays.length - 1].push(obj);

    }


    //月份顯示
    this.printMonth = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
    this.printMonth = _.chunk(this.printMonth, 3)


    this.emitMonth.emit(this.YYYY+'/'+(this.MM+1)+'/01')

  }

  //下一月
  setdown() {
    if (this.MM == 0) {
      this.MM = 11;
      this.YYYY--;
    }
    else this.MM--;

    this.createCale();
  }

  //上一月
  setup() {
    if (this.MM == 11) {
      this.MM = 0;
      this.YYYY++;
    }
    else this.MM++;

    this.createCale();
  }

  //下一年
  setYdown() {
    this.YYYY--;
    this.createCale();
  }

  //上一年
  setYup() {
    this.YYYY++;
    this.createCale();
  }

  //選擇月份
  selectM(m) {

    this.MM = m;
    this.createCale();
    this.typeMonthFlag = false
  }

  //選擇日期
  selectD(dayDate) {
    this.DD = dayDate.DD
  
    let obj:Output_InfoListObj = {
      date: this.YYYY + '/' + (this.MM < 9 ? '0' : '') + (this.MM + 1) + '/' + (this.DD < 9 ? '0' : '') + this.DD,
      content: dayDate.info
    }
    this.emitDate.emit(obj);
    console.log('送出:',obj)

  }

  //寫入Info資訊
  insertInfo(){

    //歸零
    _.each(this.printDays,row => {  
      row.forEach(day=> {
        day.info =[]
      })
    })

   
    let infoList= this.infoList
    infoList.forEach(x=>{
      let infoDay = new Date(x.date)
      
      _.each(this.printDays,row => {  
        let dayObj = _.find(row, day => {            
               
          if( infoDay.getFullYear() == this.YYYY &&
            infoDay.getMonth() == this.MM &&
            infoDay.getDate().toString() == day.DD
          ){            
            return true //找到目標日
          }  
        })

       
        if(dayObj){
          dayObj.info = x.content;
          console.log('insert!!');
          return false  //跳出整個迴圈
        }

      });
      
    })

    console.log('printDays', this.printDays)

    




  }

  //托拽開始
  dragstart_handler(ev,info,date) {
   let json = JSON.stringify({
     date:date,
     info:info
   })

    ev.dataTransfer.setData("text/plain", json);
    
  }

  //托拽結束
  drop_handler(ev,tdData){
    ev.preventDefault();
    let jsonStr = ev.dataTransfer.getData("text");
    // console.log('time',time)
    // console.log('tdData',tdData)
    let data = JSON.parse( jsonStr )
    console.log('data',data)
    
    if(data.date == tdData.DD) return

    if(tdData.info){     
      tdData.info.push({
        color: data.info.color ? data.info.color : null,
        msg : data.info.msg,
        id:data.id
      })
    }
    else{
      tdData = _.assign(tdData, {info:[{
        color: data.info.color ? data.info.color : null,
        msg : data.info.msg,
        id:data.id
      }]})
    }

    let obj:Output_InfoListObj = {
      date: this.YYYY + '/' + (this.MM < 9 ? '0' : '') + (this.MM + 1) + '/' + (this.DD < 9 ? '0' : '') + tdData.DD,
      content: tdData.info
    }

    this.emitDateDrow.emit(obj);

    console.log("GO",obj)
  }
  //托拽移入過
  dragover_handler(ev){
    ev.preventDefault();
    ev.dataTransfer.dropEffect = "move"
  }

}

//日曆內容
class PrintDayObj {
  DD: string;
  info: Array<InfoObj>;
}

//日曆資訊格式
class InfoObj {
  color: string;
  msg: string;
  id:string;
}

//對外接收資料的格式
class Input_InfoListObj {
  date: string;
  content: Array<InfoObj>;
}


//對外送出資料格式
class Output_InfoListObj {
  date: string;
  content: Array<InfoObj>;
}


